module.exports = __webpack_public_path__ + "img/mastercard.daea0413.svg";